// extracted by mini-css-extract-plugin
module.exports = {"t51mhlj":"t51mhlj","t1l1pyu0":"t1l1pyu0"};